import { render, staticRenderFns } from "./trainingSafeLevel.vue?vue&type=template&id=4ecddc20&scoped=true"
import script from "./trainingSafeLevel.vue?vue&type=script&lang=js"
export * from "./trainingSafeLevel.vue?vue&type=script&lang=js"
import style0 from "./trainingSafeLevel.vue?vue&type=style&index=0&id=4ecddc20&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecddc20",
  null
  
)

export default component.exports